var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.getYears,"label":_vm.getLabel,"item-value":"text"},on:{"change":function($event){return _vm.setYear()}},model:{value:(_vm.selected_year),callback:function ($$v) {_vm.selected_year=$$v},expression:"selected_year"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-609bfcd8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/global/year_picker.vue
// module id = 1285
// module chunks = 3